const Page500 = ({ error }) => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold">Chyba načítání stránky</h1>
        <p className="text-gray-600">{error}</p>
      </div>
    </div>
  );
};
export default Page500;
